var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRectaLogoGranat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 646 232",
    style: {
      enableBackground: "new 0 0 646 232"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M107.27,177.95c-19.09,0-23.67-7.71-30.1-15.6c-4.03-5.14-17.8-22.94-26.79-36.15h-7.71v24.95 c0,11.56,0.55,15.6,2.39,18.35c1.47,2.02,4.4,4.22,9.36,4.59v3.31c-7.16-0.37-17.61-0.74-24.04-0.74c-6.42,0-17.25,0.37-24.41,0.74 v-3.31c2.39,0,6.24-0.92,8.99-4.04c3.12-3.49,3.3-8.63,3.3-24.41V82.53c0-11.56-0.55-15.6-2.38-18.35 c-1.47-2.02-4.41-4.22-9.36-4.59v-3.3c7.15,0.37,13.4,0.55,19.82,0.55c13.21,0,16.33-0.55,28.08-0.55c4.22,0,13.58,0,20.92,1.84 c21.84,5.5,24.41,21.83,24.41,29.18c0,9.54-3.3,26.79-26.79,33.4c0,0,20.37,23.49,31.2,35.97c8.99,10.09,15.23,17.06,22.94,17.43 v3.12C127.09,177.21,122.86,177.95,107.27,177.95 M50.56,63.44c-3.85,0-7.89,0.54-7.89,0.54v54.32c0,0,4.22,0.37,8.62,0.37 c2.57,0,5.14-0.19,7.16-0.74c2.57-0.74,14.68-2.94,14.68-27.89C73.14,64.18,57.72,63.44,50.56,63.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M212.44,177.03h-51.38c-10.28,0-20.19-0.18-30.46,0.37v-3.31c2.39,0,6.24-0.92,8.99-4.04 c3.12-3.49,3.3-8.63,3.3-24.41V82.53c0-11.56-0.55-15.6-2.38-18.35c-1.47-2.02-4.4-4.22-9.36-4.59v-3.3 c10.09,0.55,17.98,0.55,28.26,0.55h52.48c0,0-0.18,15.23,0.55,23.67h-3.86c-0.18-6.24-2.75-10.46-6.24-12.48 c-4.04-2.38-7.71-2.75-19.09-2.75h-15.05v44.96h15.41c6.61,0,11.56-0.37,14.86-3.12c2.57-2.02,4.4-5.51,4.77-10.83h3.85 c0,4.04-0.36,6.61-0.36,18.17c0,11.38,0.18,13.58,0.36,17.8h-3.85c-0.37-4.77-1.83-7.89-4.04-9.91c-3.85-3.3-9.54-3.67-15.97-3.67 h-15.05v40.56c0,8.25,1.47,9.36,11.38,9.36h3.12c10.09,0,17.43-0.37,22.02-4.96c2.38-2.38,4.22-6.78,4.4-12.29H213 C212.26,159.78,212.44,177.03,212.44,177.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M522.75,80.51c-0.19-6.24-2.84-10.46-6.45-12.48c-4.17-2.38-7.96-2.75-19.71-2.75h-7.02v85.69 c0,11.56,0.57,15.59,2.46,18.16c3.03,4.41,11.56,4.78,13.46,4.78v3.49c-7.39-0.37-22.56-0.74-29.2-0.74 c-6.64,0-21.99,0.37-29.39,0.74v-3.31c1.51,0,9.48-0.55,13.08-4.4c3.22-3.49,3.41-8.26,3.41-24.04V65.28h-7.01 c-11.76,0-15.55,0.36-19.72,2.75c-3.6,2.02-6.26,6.24-6.44,12.48h-3.98c0.76-8.44,0.57-23.67,0.57-23.67h99.35 c0,0-0.19,15.23,0.57,23.67H522.75z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M616.22,176.66c-5.69,0-19.72,0.37-25.22,0.73v-3.3c4.55,0,7.4-0.92,8.91-2.21c1.14-0.92,1.7-2.38,1.7-4.03 c0-2.2-0.95-5.32-2.84-10.46l-9.1-25.32h-35.46l-9.67,25.51c-1.9,5.14-3.03,8.07-3.03,10.46c0,1.65,0.38,2.94,1.52,3.85 c2.08,2.02,6.07,2.02,8.72,2.21v3.3c-6.63-0.36-11.18-0.73-18.01-0.73c-6.07,0-11.57,0.18-17.63,0.73v-3.3 c5.31,0.18,8.15-3.67,9.29-5.32c1.52-2.2,4.36-8.63,9.29-20.01l39.44-92.48l13.84-2.39l34.12,93.22 c4.74,12.66,8.15,20.55,8.91,21.83c1.14,1.65,3.6,5.32,8.91,5.14v3.3C634.42,177.03,621.72,176.66,616.22,176.66 M578.11,99.41 c-4.17-11.56-5.12-16.52-5.12-16.52L557.25,124h29.58L578.11,99.41z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M410.67,153.29c-15.97,31.11-50.16,49.88-86.26,44.16c-39.56-6.27-68.34-39.89-70.52-78.95v-3.31 c2.18-39.06,30.96-72.68,70.52-78.95c36.09-5.72,70.29,13.05,86.26,44.16c-15.59-33.8-51.72-54.55-89.93-48.49 c-41.3,6.55-71.14,42.2-72.33,83.19h0v0.15c0,0.05-0.01,0.11-0.01,0.17h0.01v2.84h-0.01c0,0.05,0.01,0.11,0.01,0.16v0.08h0 c1.16,41.02,31,76.72,72.33,83.27C358.95,207.84,395.08,187.09,410.67,153.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M221.93,127.31c0,0,3.66-6.83,10.54-9.87c1.2-0.53,2.42-0.9,3.62-1.17c-1.2-0.27-2.41-0.64-3.62-1.17 c-6.88-3.04-10.54-9.87-10.54-9.87s7.51-1.89,14.39,1.15c6.89,3.04,10.54,9.87,10.54,9.87s-0.03,0.01-0.08,0.02 c0.05,0.01,0.08,0.02,0.08,0.02s-3.66,6.82-10.54,9.86C229.44,129.2,221.93,127.31,221.93,127.31z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M240.04,91.32c5.97,5.91,7.08,14.48,7.08,14.48s-8.59-1.01-14.56-6.92c-5.98-5.91-7.08-14.48-7.08-14.48 S234.07,85.41,240.04,91.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M236.35,83.39c-5.47-6.38-5.88-15.02-5.88-15.02s8.48,1.7,13.96,8.09c5.47,6.38,5.87,15.02,5.87,15.02 S241.82,89.77,236.35,83.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M259.8,52.49c3.27,7.06,1.45,14.85,1.45,14.85s-7.12-3.66-10.39-10.71c-3.27-7.06-1.45-14.85-1.45-14.85 S256.54,45.43,259.8,52.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M242.82,69.47c-4.83-6.39-4.7-14.64-4.7-14.64s7.96,2.13,12.8,8.52c4.83,6.4,4.69,14.64,4.69,14.64 S247.65,75.86,242.82,69.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M260.29,45.87c-2.2-7.23,0.59-14.49,0.59-14.49s6.36,4.47,8.56,11.7c2.2,7.23-0.59,14.49-0.59,14.49 S262.49,53.1,260.29,45.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M271.12,36.16c-0.85-7.31,3.09-13.77,3.09-13.77s5.32,5.39,6.17,12.7c0.85,7.31-3.09,13.78-3.09,13.78 S271.97,43.47,271.12,36.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M282.7,28.53c0.08-7.36,4.8-13.27,4.8-13.27s4.59,6.02,4.51,13.37c-0.08,7.36-4.8,13.28-4.8,13.28 S282.62,35.89,282.7,28.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M295.27,22.01c0.89-6.99,6.02-12.1,6.02-12.1s3.71,6.23,2.83,13.22c-0.88,7-6.03,12.11-6.03,12.11 S294.39,29,295.27,22.01"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M308.18,17.37c1.38-6.91,6.88-11.64,6.88-11.64s3.25,6.48,1.87,13.39c-1.38,6.92-6.88,11.64-6.88,11.64 S306.8,24.28,308.18,17.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M320.68,16.41c2.03-6.54,7.81-10.56,7.81-10.56s2.5,6.58,0.48,13.12c-2.03,6.55-7.81,10.57-7.81,10.57 S318.65,22.96,320.68,16.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M333.43,16.46c2.82-5.92,8.85-8.94,8.85-8.94s1.47,6.58-1.35,12.5c-2.81,5.92-8.84,8.94-8.84,8.94 S330.62,22.38,333.43,16.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M345.84,17.94c3.2-5.29,9.14-7.56,9.14-7.56s0.76,6.31-2.44,11.61c-3.2,5.29-9.14,7.56-9.14,7.56 S342.65,23.23,345.84,17.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M357.25,20.63c3.64-4.47,9.41-5.8,9.41-5.8s-0.11,5.93-3.75,10.41c-3.63,4.48-9.42,5.8-9.42,5.8 S353.62,25.11,357.25,20.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M367.86,24.23c4.04-3.46,9.5-3.71,9.5-3.71s-1.08,5.36-5.12,8.82c-4.04,3.46-9.5,3.71-9.5,3.71 S363.82,27.69,367.86,24.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M376.83,28.71c4.27-2.9,9.56-2.55,9.56-2.55s-1.62,5.05-5.89,7.96c-4.27,2.9-9.57,2.56-9.57,2.56 S372.55,31.62,376.83,28.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M385.11,35c4.46-2.02,9.35-0.84,9.35-0.84s-2.33,4.46-6.79,6.49c-4.46,2.02-9.36,0.84-9.36,0.84 S380.65,37.03,385.11,35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M393.14,41.24c4.31-1.13,8.51,0.67,8.51,0.67s-2.77,3.64-7.08,4.78c-4.31,1.14-8.52-0.67-8.52-0.67 S388.83,42.38,393.14,41.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M399.63,47.87c4.14-0.62,7.88,1.5,7.88,1.5s-2.96,3.12-7.1,3.73c-4.13,0.62-7.88-1.5-7.88-1.5 S395.49,48.5,399.63,47.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M405.12,54.66c3.78-0.2,6.98,2.02,6.98,2.02s-2.93,2.56-6.72,2.77c-3.78,0.21-6.98-2.01-6.98-2.01 S401.34,54.87,405.12,54.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M409.02,61.44c3.5,0.09,6.28,2.38,6.28,2.38s-2.89,2.15-6.39,2.06c-3.5-0.09-6.28-2.37-6.28-2.37 S405.52,61.35,409.02,61.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M412,67.78c3.07,0.66,5.15,3.13,5.15,3.13s-2.91,1.42-5.98,0.76c-3.08-0.66-5.15-3.13-5.15-3.13 S408.92,67.13,412,67.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M415.9,74.61c2.87,0.95,4.6,3.53,4.6,3.53s-2.93,1.05-5.8,0.1c-2.87-0.94-4.6-3.53-4.6-3.53 S413.03,73.67,415.9,74.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M417.22,83.36c2.37,2.12,2.96,5.34,2.96,5.34s-3.26-0.21-5.64-2.33c-2.37-2.11-2.96-5.34-2.96-5.34 S414.84,81.24,417.22,83.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M240.04,141.19c5.97-5.91,7.08-14.49,7.08-14.49s-8.59,1.01-14.56,6.92c-5.98,5.91-7.08,14.49-7.08,14.49 S234.07,147.1,240.04,141.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M236.35,149.12c-5.47,6.38-5.88,15.02-5.88,15.02s8.48-1.71,13.96-8.09c5.47-6.38,5.87-15.02,5.87-15.02 S241.82,142.74,236.35,149.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M259.8,180.02c3.27-7.06,1.45-14.85,1.45-14.85s-7.12,3.66-10.39,10.71c-3.27,7.07-1.45,14.85-1.45,14.85 S256.54,187.08,259.8,180.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M242.82,163.04c-4.83,6.39-4.7,14.64-4.7,14.64s7.96-2.13,12.8-8.52c4.83-6.4,4.69-14.64,4.69-14.64 S247.65,156.64,242.82,163.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M260.29,186.64c-2.2,7.23,0.59,14.49,0.59,14.49s6.36-4.47,8.56-11.71c2.2-7.23-0.59-14.49-0.59-14.49 S262.49,179.41,260.29,186.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M271.12,196.35c-0.85,7.31,3.09,13.77,3.09,13.77s5.32-5.39,6.17-12.7c0.85-7.31-3.09-13.77-3.09-13.77 S271.97,189.04,271.12,196.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M282.7,203.98c0.08,7.36,4.8,13.27,4.8,13.27s4.59-6.01,4.51-13.37c-0.08-7.36-4.8-13.28-4.8-13.28 S282.62,196.62,282.7,203.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M295.27,210.5c0.89,6.99,6.02,12.1,6.02,12.1s3.71-6.23,2.83-13.22c-0.88-7-6.03-12.11-6.03-12.11 S294.39,203.51,295.27,210.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M308.18,215.14c1.38,6.91,6.88,11.64,6.88,11.64s3.25-6.48,1.87-13.39c-1.38-6.91-6.88-11.64-6.88-11.64 S306.8,208.24,308.18,215.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M320.68,216.1c2.03,6.54,7.81,10.56,7.81,10.56s2.5-6.58,0.48-13.12c-2.03-6.54-7.81-10.57-7.81-10.57 S318.65,209.56,320.68,216.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M333.43,216.05c2.82,5.92,8.85,8.94,8.85,8.94s1.47-6.58-1.35-12.51c-2.81-5.92-8.84-8.94-8.84-8.94 S330.62,210.13,333.43,216.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M345.84,214.57c3.2,5.29,9.14,7.56,9.14,7.56s0.76-6.31-2.44-11.6c-3.2-5.3-9.14-7.56-9.14-7.56 S342.65,209.28,345.84,214.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M357.25,211.88c3.64,4.47,9.41,5.8,9.41,5.8s-0.11-5.93-3.75-10.41c-3.63-4.48-9.42-5.8-9.42-5.8 S353.62,207.4,357.25,211.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M367.86,208.28c4.04,3.46,9.5,3.71,9.5,3.71s-1.08-5.36-5.12-8.82c-4.04-3.46-9.5-3.71-9.5-3.71 S363.82,204.82,367.86,208.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M376.83,203.8c4.27,2.9,9.56,2.55,9.56,2.55s-1.62-5.06-5.89-7.96c-4.27-2.91-9.57-2.56-9.57-2.56 S372.55,200.89,376.83,203.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M385.11,197.51c4.46,2.02,9.35,0.84,9.35,0.84s-2.33-4.46-6.79-6.49c-4.46-2.03-9.36-0.84-9.36-0.84 S380.65,195.48,385.11,197.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M393.14,191.27c4.31,1.13,8.51-0.67,8.51-0.67s-2.77-3.65-7.08-4.79c-4.31-1.14-8.52,0.67-8.52,0.67 S388.83,190.13,393.14,191.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M399.63,184.64c4.14,0.62,7.88-1.5,7.88-1.5s-2.96-3.12-7.1-3.74c-4.13-0.62-7.88,1.5-7.88,1.5 S395.49,184.01,399.63,184.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M405.12,177.85c3.78,0.2,6.98-2.02,6.98-2.02s-2.93-2.56-6.72-2.77c-3.78-0.21-6.98,2.01-6.98,2.01 S401.34,177.64,405.12,177.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M409.02,171.07c3.5-0.09,6.28-2.38,6.28-2.38s-2.89-2.14-6.39-2.06c-3.5,0.09-6.28,2.38-6.28,2.38 S405.52,171.16,409.02,171.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M412,164.73c3.07-0.66,5.15-3.14,5.15-3.14s-2.91-1.41-5.98-0.76c-3.08,0.65-5.15,3.13-5.15,3.13 S408.92,165.38,412,164.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M415.9,157.9c2.87-0.95,4.6-3.54,4.6-3.54s-2.93-1.05-5.8-0.1c-2.87,0.95-4.6,3.53-4.6,3.53 S413.03,158.84,415.9,157.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M417.22,149.15c2.37-2.12,2.96-5.34,2.96-5.34s-3.26,0.21-5.64,2.33c-2.37,2.12-2.96,5.34-2.96,5.34 S414.84,151.26,417.22,149.15"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M278.52,100.22c-7.4,3.28-15.47,1.24-15.47,1.24s3.93-7.36,11.33-10.64c7.4-3.28,15.47-1.24,15.47-1.24 S285.92,96.93,278.52,100.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M284.27,86.59c-7.51,1.78-14.72-1.54-14.72-1.54s4.96-6.21,12.47-8c7.51-1.78,14.72,1.55,14.72,1.55 S291.78,84.81,284.27,86.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M291.43,74.67c-7.48,0.5-13.85-3.84-13.85-3.84s5.75-5.15,13.22-5.65c7.48-0.5,13.85,3.85,13.85,3.85 S298.9,74.17,291.43,74.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M301.77,64.48c-7.25-0.64-12.72-5.77-12.72-5.77s6.28-4.08,13.53-3.43c7.25,0.65,12.72,5.78,12.72,5.78 S309.02,65.12,301.77,64.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M314.59,56.79c-6.68-2.07-10.79-7.98-10.79-7.98s6.72-2.57,13.39-0.5c6.68,2.06,10.79,7.98,10.79,7.98 S321.27,58.85,314.59,56.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M328.97,51.67c-5.85-2.92-8.76-9-8.76-9s6.58-1.35,12.44,1.56c5.85,2.92,8.76,9,8.76,9 S334.82,54.58,328.97,51.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M342.67,49.06c-4.56-3.52-6.05-9.28-6.05-9.28s5.93-0.04,10.5,3.48c4.57,3.52,6.05,9.28,6.05,9.28 S347.24,52.58,342.67,49.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M356.15,50.25c-3.63-3.91-4.1-9.37-4.1-9.37s5.41,0.86,9.03,4.77c3.62,3.91,4.1,9.37,4.1,9.37 S359.78,54.16,356.15,50.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M366.88,53.2c-2.62-4.38-1.98-9.58-1.98-9.58s4.88,1.88,7.5,6.26c2.62,4.37,1.98,9.59,1.98,9.59 S369.5,57.57,366.88,53.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M377.26,57.91c-2.04-4.09-1.12-8.7-1.12-8.7s4.23,2.02,6.27,6.1c2.04,4.09,1.12,8.69,1.12,8.69 S379.3,62,377.26,57.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M386.3,63.13c-1.44-3.94-0.12-8.05-0.12-8.05s3.66,2.28,5.1,6.21c1.44,3.94,0.12,8.05,0.12,8.05 S387.75,67.07,386.3,63.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M393.99,70.59c-0.91-3.8,0.74-7.45,0.74-7.45s3.13,2.5,4.05,6.3c0.91,3.79-0.74,7.45-0.74,7.45 S394.9,74.38,393.99,70.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M399.71,78.67c-0.27-3.6,1.79-6.68,1.79-6.68s2.48,2.75,2.75,6.34c0.27,3.6-1.79,6.68-1.79,6.68 S399.97,82.27,399.71,78.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M405.12,85.89c-0.24-3.22,1.6-5.99,1.6-5.99s2.23,2.46,2.47,5.69c0.24,3.22-1.6,5.99-1.6,5.99 S405.37,89.11,405.12,85.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M285.09,127.32c0,0-3.52-6.59-10.15-9.53c-1.16-0.51-2.33-0.87-3.48-1.13c1.15-0.26,2.32-0.62,3.48-1.13 c6.63-2.94,10.15-9.53,10.15-9.53s-7.23-1.83-13.86,1.11c-6.63,2.94-10.15,9.53-10.15,9.53s0.03,0,0.08,0.02 c-0.05,0.01-0.08,0.02-0.08,0.02s3.52,6.59,10.15,9.53C277.87,129.15,285.09,127.32,285.09,127.32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M278.52,133.11c-7.4-3.28-15.47-1.24-15.47-1.24s3.93,7.36,11.33,10.65c7.4,3.28,15.47,1.24,15.47,1.24 S285.92,136.39,278.52,133.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M284.27,146.74c-7.51-1.78-14.72,1.54-14.72,1.54s4.96,6.21,12.47,7.99c7.51,1.78,14.72-1.54,14.72-1.54 S291.78,148.51,284.27,146.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M291.43,158.65c-7.48-0.5-13.85,3.84-13.85,3.84s5.75,5.15,13.22,5.65c7.48,0.5,13.85-3.85,13.85-3.85 S298.9,159.15,291.43,158.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M301.77,168.84c-7.25,0.65-12.72,5.78-12.72,5.78s6.28,4.08,13.53,3.44c7.25-0.65,12.72-5.78,12.72-5.78 S309.02,168.2,301.77,168.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M314.59,176.53c-6.68,2.07-10.79,7.98-10.79,7.98s6.72,2.57,13.39,0.5c6.68-2.06,10.79-7.98,10.79-7.98 S321.27,174.47,314.59,176.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M328.97,181.66c-5.85,2.92-8.76,9-8.76,9s6.58,1.35,12.44-1.56c5.85-2.92,8.76-9,8.76-9 S334.82,178.74,328.97,181.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M342.67,184.26c-4.56,3.52-6.05,9.28-6.05,9.28s5.93,0.04,10.5-3.48c4.57-3.52,6.05-9.28,6.05-9.28 S347.24,180.74,342.67,184.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M356.15,183.07c-3.63,3.91-4.1,9.37-4.1,9.37s5.41-0.86,9.03-4.77c3.62-3.91,4.1-9.37,4.1-9.37 S359.78,179.17,356.15,183.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M366.88,180.13c-2.62,4.37-1.98,9.58-1.98,9.58s4.88-1.88,7.5-6.26c2.62-4.38,1.98-9.58,1.98-9.58 S369.5,175.75,366.88,180.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M377.26,175.41c-2.04,4.09-1.12,8.7-1.12,8.7s4.23-2.02,6.27-6.1c2.04-4.09,1.12-8.7,1.12-8.7 S379.3,171.33,377.26,175.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M386.3,170.19c-1.44,3.94-0.12,8.05-0.12,8.05s3.66-2.28,5.1-6.22c1.44-3.94,0.12-8.05,0.12-8.05 S387.75,166.25,386.3,170.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M393.99,162.73c-0.91,3.8,0.74,7.45,0.74,7.45s3.13-2.5,4.05-6.29c0.91-3.79-0.74-7.45-0.74-7.45 S394.9,158.94,393.99,162.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M399.71,154.65c-0.27,3.6,1.79,6.68,1.79,6.68s2.48-2.75,2.75-6.34c0.27-3.6-1.79-6.68-1.79-6.68 S399.97,151.06,399.71,154.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M405.12,147.44c-0.24,3.22,1.6,5.99,1.6,5.99s2.23-2.46,2.47-5.69c0.24-3.22-1.6-5.99-1.6-5.99 S405.37,144.21,405.12,147.44"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M410.67,153.29c-15.44,30.08-48.52,47.02-83.42,41.49c-38.24-6.06-66.07-38.57-68.18-76.33v-3.2 c2.11-37.76,29.93-70.27,68.18-76.32c34.9-5.53,67.98,11.41,83.42,41.48c-15.07-32.68-50.02-51.53-86.97-45.67 c-39.93,6.33-68.77,40.8-69.92,80.43h0v0.14c0,0.05-0.01,0.11-0.01,0.16h0.01v2.75h-0.01c0,0.05,0.01,0.11,0.01,0.16v0.08h0 c1.12,39.66,29.97,74.17,69.93,80.51C360.64,204.82,395.6,185.97,410.67,153.29"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRectaLogoGranat);
export default __webpack_public_path__ + "static/media/RECTA_logo_granat.9af5efa9bf794813ee0a109504b731f1.svg";
export { ForwardRef as ReactComponent };